import { ChipInfoStatusEnum } from "../ChipInfo/chipInfo.interface"
import { StatusWorkOrderEnum } from "../status.interface"

export const workOrderChip = (type: StatusWorkOrderEnum): ChipInfoStatusEnum => {
  switch (type) {
    case StatusWorkOrderEnum.New:
      return ChipInfoStatusEnum.New
    case StatusWorkOrderEnum.Sent:
      return ChipInfoStatusEnum.Sent
    case StatusWorkOrderEnum.Booked:
      return ChipInfoStatusEnum.Booked
    case StatusWorkOrderEnum.Resolved:
      return ChipInfoStatusEnum.Resolved
    case StatusWorkOrderEnum.Completed:
      return ChipInfoStatusEnum.Completed
    case StatusWorkOrderEnum.Declined:
      return ChipInfoStatusEnum.Declined
    default:
      return ChipInfoStatusEnum.New
  }
}
